module.exports = __webpack_public_path__ + "media/message 11.47198c45.mp3";